import { useApiClient } from "../../shared/customHooks";
import { useParams } from "react-router";
import FormContainer from "../../components/form/FormContainer";
import { userForm } from "../../shared/formObjects/userForm";
import { Header } from "../../components/header/Header";
import { PageHeader } from "../../components/header/PageHeader";
import ResetMFAButtonComponent from "../../components/form/components/ResetMFAButtonComponent";
import { useGlobalContext } from "../../shared/GlobalContext";
import { canRoleAManageRoleB, RoleId } from "../../shared/enums/Role";
import { useState } from "react";

export default function EditUser() {
  const api = useApiClient("UserManagement", { identity: true });
  const { id } = useParams<{ id: string }>();
  const { accountInfo } = useGlobalContext();
  const [disableResetMFA, setDisableResetMFA] = useState<boolean>(true);
  const [hideFormButtons, setHideFormButtons] = useState<boolean>(true);

  const headerText = [
    {
      class: "flex items-center mt-0",
      value: `${id ? "Edit" : "Add"} User`,
      icon: "view-app-icon icon-spec mr-3 mt-0",
    },
  ];

  // Get editor's roleId
  const roleTitleCase = accountInfo.role.charAt(0).toUpperCase() + accountInfo.role.slice(1);
  const roleId = RoleId[roleTitleCase as keyof typeof RoleId];

  function getInitialValues(initialData: any) {
    if (roleId != null) {
      // Disable if targetted user does not have MFA or if the editor has lower authority than the user being edited
      const editorCanManageUser = canRoleAManageRoleB(roleId, initialData.roleId);

      setDisableResetMFA(!initialData.hasMFA || !editorCanManageUser);
      setHideFormButtons(!editorCanManageUser);
    }
  }

  return (
    <>
      <Header />
      <PageHeader headerText={headerText} icon={"icon"} />
      <div className="p-5 mfa flex flex-col text-left">
        <FormContainer
          apiClient={api}
          formBody={userForm(roleId)}
          id={id}
          showInternalNotes={false}
          cancelPath=".."
          submitRoute=".."
          getInitialValues={getInitialValues}
          hideSubmitButton={hideFormButtons}
          hideCancelButton={hideFormButtons}
        />
        {id && (
          <ResetMFAButtonComponent
            userId={id}
            disabled={disableResetMFA}
            setDisabled={setDisableResetMFA}
            disabledLabel="MFA not enabled for this user"
            hideDisabledLabel={hideFormButtons}
          />
        )}
      </div>
    </>
  );
}
